<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 分类名称" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >总充值：{{total_list.total}}</el-tag> -->
					<el-button class="mr-2"  @click="openModel(false)" type="primary" size="mini" 
					v-auth="'add'+auth_val">添加分类</el-button>
					<!-- <el-button type="warning" v-auth="'add'+auth_val" @click="openModel(2)" size="mini">出库</el-button> -->

				</template>

				<!-- 高级搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="分类名称" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索产品名称"></el-input>
						</el-form-item>
						
					
			
						<el-form-item label="项目类型" class="mb-0">
							<el-select v-model="from.parent_type" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="销售成本" :value="1"></el-option>
								<el-option label="管理成本" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item label="对应产品" class="mb-0">
							<el-select v-model="from.is_product" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="不需要" :value="0"></el-option>
								<el-option label="需要" :value="1"></el-option>
							</el-select>
						</el-form-item>
						
					


						<el-form-item label="时间" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column>
			
				
			
		
				
				<el-table-column align="center" prop="name" label="分类名称">
				</el-table-column>
				
				
				<el-table-column align="center"  prop="parent_type"  label="所属项目">
					<template slot-scope="v">
						<span v-if="v.row.parent_type==1">销售成本</span>
						<span v-if="v.row.parent_type==2">管理成本</span>
						
					</template>
				</el-table-column>
			
				
		
				
				<el-table-column align="center" prop="num"  label="是否需要对应产品">
					<template slot-scope="v">
						
						<span style="color: #999;" v-if="v.row.is_product==0">不需要</span>
						<span style="color: #67C23A;" v-else> 需要</span>
						
						
						
					</template>
				</el-table-column>
				
				
				
	
			
		
				
				<el-table-column align="center" sortable="custom" prop="status"  label="状态">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '启用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="时间">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="80" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,3)">编辑</el-button>
							
						

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :title="editIndex==-1?'添加分类':'修改分类'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				
				
				<el-form-item label="所属项目"   prop="parent_type">
					<el-radio-group :disabled="editIndex>0?true:false" v-model="form.parent_type">
					    <el-radio :label="1">销售成本</el-radio>
					    <el-radio :label="2">管理成本</el-radio>
					  </el-radio-group>
				</el-form-item>
				
				
				
				
				<el-form-item label="选择相应产品"   prop="parent_type">
					<el-radio-group  v-model="form.is_product">
					    <el-radio :label="0">不需要</el-radio>
					    <el-radio :label="1">需要</el-radio>
					  </el-radio-group>
				</el-form-item>
			
				
			
				
				<el-form-item label="分类名称" prop="name">
					<el-input type="text" v-model="form.name" 
					placeholder="分类名称" 
					clearable size="small" style="width: 85%;">
					
					</el-input>
				</el-form-item>
				
			
				
				
				
			
			
				
		
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {
					name: [{
							required: true,
							message: "分类名称不能为空",
							trigger: 'blur',
						},
					],
				
					
					
				},
				createModel: false,
				editIndex: -1,
				//搜索数据
				from: {
					name:"",
					parent_type:-1,
					is_product:-1,
					time: [],
				},
				model_title: 'Costclass',
				auth_val: 'Costclass',
				preUrl: "data/costclassList", //列表地址
				addUrl: "data/addCostclass", //添加/修改地址
				editStatusUrl: "data/editStatusCostclass", //修改状态地址
				tableData: [],
				form: {
					id: 0,
					parent_type:1,
					name:"",
					is_product:0,
					
				},
				prop: 'create_time',
				sort: 'descending',
				slist: [],
				plist: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('pnumList');
		},
		methods: {
			checkPnum(){
				if(this.form.sid && this.form.pid){
					//console.log("查询")
					this.checkPnumApi()
				}
			},
			checkPnumApi(){
					this.axios.post('/admin/data/CheckPnum',
						this.form
					, {
						token: true,
					}).then(res => {
						let all = res.data
						
						this.now_num = all.data.list
						 
						
				
						
					}).catch(err => {
						// 失败
						
					})
				
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
				
					this.slist = list.slist
					this.plist = list.plist
			
					this.layout.loading = false;
				}).catch(err => {
					// 失败
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						
					// 	if(!this.form.head){
					// 		this.$message.error('请传入店铺图片');
					// 		return false
					// 	}
					
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 关闭模态框
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				// if (!isJPG) {
				//   this.$message.error('上传头像图片只能是 JPG 格式!');
				// }
				// if (!isLt2M) {
				//   this.$message.error('上传头像图片大小不能超过 2MB!');
				// }
				return isJPG && isLt2M;
			  },
			

			// 打开模态框
			openModel(e, type) {
				
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						parent_type: e.parent_type,
						name: e.name,
						is_product:e.is_product,
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						parent_type:1,
						name:"",
						is_product:0,
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空筛选条件
			clearSearch() {
				this.from = {
					name:"",
					parent_type:-1,
					is_product:-1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 选择图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
